<template>
  <div>

    <el-dialog
      :title="data.ModalBaslik"
      :visible="BinaDestekModal"
      center
      :width="data.id?'60%':'30%'">
      <a @click="$emit('BinaDestekModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-row :gutter="24">
        <el-col :span="data.id?18:24">
          <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
            <el-form-item v-if="!data.id" label="Kişi" prop="Kisi_id">
              <el-select v-model="data.Kisi_id" filterable>
                <el-option
                  v-for="item in Kisiler"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <h5 v-if="data.id">{{data.AdSoyad}}
              <hr>
            </h5>

            <el-form-item label="Talep Başlık" prop="Baslik">
              <el-input v-model="data.Baslik"></el-input>
            </el-form-item>
            <el-form-item label="Talep İçeriği" prop="Aciklama">
              <el-input type="textarea" v-model="data.Aciklama"></el-input>
            </el-form-item>
            <el-form-item v-if="data.id" label="Durum" prop="Durum">
              <el-select v-model="data.Durum" filterable>
                <el-option
                  v-for="item in Durums"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" v-if="data.id">
          <Notlar v-if="Notlar" :data="Notlar"></Notlar>
        </el-col>

      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          Kaydet
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Notlar from "../../../../Genel/Notlar";

  export default {
    components: {Notlar},
    props: ['BinaDestekModal', 'data'],
    data() {
      return {
        Notlar: null,
        Kisiler: null,
        Durums: [
          {value: "1", label: "Beklemede"},
          {value: "2", label: "İşlem Yapılıyor"},
          {value: "3", label: "Tamamlandı"},
        ],
        FormHata: {
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Baslik: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            if (this.data.id) {
              this.$store.dispatch("Put", {...this.data, path: 'yonetim/bina/destek/' + this.data.id})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("BinaDestekModal", false);
                    this.$message.success(response.Mesaj);
                    //this.$router.push('/yonetim/bina')
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            } else {

              this.$store.dispatch("Post", {...this.data, path: 'yonetim/bina/destek'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("BinaDestekModal", false);
                    this.$message.success(response.Mesaj);
                    //this.$router.push('/yonetim/bina')
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      NotConfig() {
        if (this.data.id) {
          this.Notlar = {
            Modul: 'Destek',
            Modul_id: this.data.id
          }
        }
      },
      SayfaYukle() {

        this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/b/' + this.data.Bina_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kisiler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.NotConfig();
    },
    computed: {
      rSAyfaYukle() {
        return this.BinaDestekModal
      },
    },
    watch: {
      rSAyfaYukle() {
        this.NotConfig();
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/Toplanti/BinaDestekModal.vue